import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { showContentTypes, toggleShowWorkbooksAsViews } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectSpecificMixedContentFilterClause } from '~src/spacesPlatform/selectors/ContentFilterSelectors';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { ContentFiltersKeys } from '../../spacesPlatform/models/ContentFilters';
import { IStringValuedFilterClause } from '../../spacesPlatform/models/IFilterClause';
import { BackgroundJobsSpace, BackgroundJobsSpaceDispatchProps, BackgroundJobsSpaceOwnProps, BackgroundJobsSpaceStateProps } from './BackgroundJobsSpace';


const mapStateToProps: MapStateToProps<BackgroundJobsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  statusFilter: selectSpecificMixedContentFilterClause(state, ContentFiltersKeys.backgroundJobStatus) as IStringValuedFilterClause,
});

const mapDispatchToProps: MapDispatchToProps<BackgroundJobsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
  requestSpaceContents: requestSpaceContents
}, dispatch);

export const ConnectedBackgroundJobsSpace: React.ComponentClass<BackgroundJobsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(BackgroundJobsSpace);
